import {RoadKill} from "../RoadKill";
import {RoadKillGameMode} from "../server/RoadKillGameMode";
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {RKHelper} from "../utils/RKHelper";
import {TimelineLite} from "gsap";

export class RoadKillBackgroundSpine extends PIXI.Container implements StageLayer {
    private _bg: PIXI.spine.Spine;

    constructor() {
        super();
        this.name = "BackgroundSpine";
        this._bg = this.createBgSpine();
        this.addChild(this._bg);
    }

    get bgSpine(): PIXI.spine.Spine {
        return this._bg;
    }

    public onOrientationChanged() {

    }

    public onResize() {

    }

    public changeBackground(mode: string): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        switch (mode) {
            case RoadKillGameMode.FREESPIN:
                tl.add(() => {
                    this.bgSpine.autoUpdate = true;
                    this.bgSpine.state.setAnimation(0, "FsBgIdle", true);
                });
                break;
            case RoadKillGameMode.SUPER_FREESPIN:
                tl.add(() => {
                    this.bgSpine.autoUpdate = true;
                    this.bgSpine.state.setAnimation(0, "SfsBgIdle", true);
                });
                break;
            case RoadKillGameMode.RESPIN:
                tl.add(() => {
                    this.bgSpine.autoUpdate = true;
                    this.bgSpine.state.setAnimation(0, "2SWBgIdle", true);
                });
                break;
            default:
                tl.add(() => {
                    this.bgSpine.autoUpdate = true;
                    this.bgSpine.state.setAnimation(0, "MainBgIdle", true);
                });
                break;
        }
        return tl;
    }

    public playTransitionAnim(animName: string, reverse: boolean = false): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        tl.add(() => {
            this._bg.state.clearTracks();
            this._bg.state.setEmptyAnimation(0, 0);
        })
        tl.add(RKHelper.playSpineWithTimeline(this._bg, 0, animName));
        return reverse ? tl.reverse() : tl;
    }

    public getTransitionDuration(animName: string): number {
        return this._bg.skeleton.data.findAnimation(animName).duration;
    }

    private createBgSpine(): PIXI.spine.Spine {
        const _bg: PIXI.spine.Spine = new PIXI.spine.Spine(RoadKill.assetLoader.getSpineAsset("bg"));
        _bg.position.set(360, 360);
        return _bg
    }

}